export const SET_TOKEN = 'SET_TOKEN';
export const SET_FLASH_MESSAGE = 'SET_FLASH_MESSAGE';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

// perfil usuario
export const FETCH_USER = 'FETCH_USER';
export const SET_USER_HEADER = 'SET_USER_HEADER';
export const SET_USER = 'SET_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const DELETE_USER = 'UPDATE_USER';

// empresa
export const FETCH_EMPRESA = 'FETCH_EMPRESA';
export const SET_EMPRESA = 'SET_EMPRESA';
export const CREATE_EMPRESA = 'CREATE_EMPRESA';
export const UPDATE_EMPRESA = 'UPDATE_EMPRESA';
export const DELETE_EMPRESA = 'DELETE_EMPRESA';
export const FETCH_EMPRESA_BY_ID = 'FETCH_EMPRESA_BY_ID';

// usuarios
export const FETCH_USUARIO = 'FETCH_USER';
export const FETCH_USUARIO_BY_ID = 'FETCH_USUARIO_BY_ID';

// proyecto
export const FETCH_PROYECTO_BY_ID = 'FETCH_PROYECTO_BY_ID';
export const FETCH_PROYECTO = 'FETCH_PROYECTO';
export const FETCH_PROYECTO_GRAFICA = 'FETCH_PROYECTO_GRAFICA';
export const FETCH_PROYECTO_BY_ID_GRAFICA = 'FETCH_PROYECTO_BY_ID_GRAFICA';

// elemento
export const FETCH_ELEMENTO_BY_ID = 'FETCH_ELEMENTO_BY_ID';
export const FETCH_ELEMENTO_BY_ID_GRAFICA = 'FETCH_ELEMENTO_BY_ID_GRAFICA';
export const FETCH_ELEMENTO = 'FETCH_ELEMENTO';

// sensor
export const FETCH_SENSOR_BY_ID = 'FETCH_SENSOR_BY_ID';
export const FETCH_SENSOR_BY_ID_GRAFICA = 'FETCH_SENSOR_BY_ID_GRAFICA';
export const FETCH_SENSOR = 'FETCH_SENSOR';
export const FETCH_SENSOR_BUSCAR = 'FETCH_SENSOR_BUSCAR';
export const UPDATE_SENSOR_REQUEST = 'UPDATE_SENSOR_REQUEST';
export const UPDATE_SENSOR_SUCCESS = 'UPDATE_SENSOR_SUCCESS';
export const UPDATE_SENSOR_ERROR = 'UPDATE_SENSOR_ERROR';

// valor sensor trama
export const FETCH_VALOR_SENSOR_TRAMA_BY_SENSOR_ID = 'FETCH_VALOR_SENSOR_TRAMA_BY_SENSOR_ID';

// tipo sensor
export const FETCH_TIPO_SENSOR = 'FETCH_TIPO_SENSOR';

// tarjeta
export const FETCH_TARJETA = 'FETCH_TARJETA';
export const FETCH_TARJETA_BY_ID = 'FETCH_TARJETA_BY_ID';
export const FETCH_TARJETA_BY_ID_GRAFICA = 'FETCH_TARJETA_BY_ID_GRAFICA';
export const FETCH_GRAFICA_COMPLETA = 'FETCH_GRAFICA_COMPLETA';
export const FETCH_GRAFICAS_COMPLETAS = 'FETCH_GRAFICAS_COMPLETAS';
export const UPDATE_TARJETA_REQUEST = 'UPDATE_TARJETA_REQUEST';
export const UPDATE_TARJETA_SUCCESS = 'UPDATE_TARJETA_SUCCESS';
export const UPDATE_TARJETA_ERROR = 'UPDATE_TARJETA_ERROR';

// grafica
export const FETCH_GRAFICA = 'FETCH_GRAFICA';
export const CREAR_GRAFICA = 'CREAR_GRAFICA';
export const FETCH_ELEMENTO_GRAFICA = 'FETCH_ELEMENTO_GRAFICA';
export const FETCH_TARJETA_GRAFICA = 'FETCH_TARJETA_GRAFICA';
export const FETCH_GRAFICA_BY_ID = 'FETCH_GRAFICA_BY_ID';
export const FETCH_GRAFICA_BY_ID_REFRESH = 'FETCH_GRAFICA_BY_ID_REFRESH';
export const FETCH_TIPO_GRAFICA = 'FETCH_TIPO_GRAFICA';
export const FETCH_SENSORES_GRAFICA = 'FETCH_SENSORES_GRAFICA';
export const ADD_SENSORES_GRAFICA = 'ADD_SENSORES_GRAFICA';
export const DELETE_SENSORES_GRAFICA = 'DELETE_SENSORES_GRAFICA';
export const CHANGE_ELEMENTO_GRAFICA = 'CHANGE_ELEMENTO_GRAFICA';
export const CHANGE_TARJETA_GRAFICA = 'CHANGE_TARJETA_GRAFICA';
export const LIMPIAR_GRAFICA = 'LIMPIAR_GRAFICA';

// reset
export const SEND_EMAIL = 'SEND_EMAIL';
export const RESET_PASS = 'RESET_PASS';

// objetivo
export const AGREGAR_OBJETIVO = 'AGREGAR_OBJETIVO';
export const FETCH_OBJETIVO_PROYECTO = 'FETCH_OBJETIVO_PROYECTO';
export const FETCH_OBJETIVO_ELEMENTO = 'FETCH_OBJETIVO_ELEMENTO';
export const FETCH_OBJETIVOS_TIPO_SENSOR = 'FETCH_OBJETIVOS_TIPO_SENSOR';

// reporte

export const FETCH_PROYECTO_REPORTE = 'FETCH_PROYECTO_REPORTE';
export const FETCH_TIPO_REPORTE = 'FETCH_TIPO_REPORTE';
export const FETCH_REPORTE_ELEMENTO_BY_ID = 'FETCH_REPORTE_ELEMENTO_BY_ID';
export const FETCH_REPORTE_TARJETA_BY_ID = 'FETCH_REPORTE_TARJETA_BY_ID';

export const FETCH_REPORTE_PROYECTO_SENSORES = 'FETCH_REPORTE_PROYECTO_SENSORES';
export const FETCH_REPORTE_ELEMENTO_SENSORES = 'FETCH_REPORTE_ELEMENTO_SENSORES';
export const FETCH_REPORTE_TARJETA_SENSORES = 'FETCH_REPORTE_TARJETA_SENSORES';
export const GENERAR_REPORTE_BASE = 'GENERAR_REPORTE_BASE';
export const GENERAR_REPORTE_ACUMULADO = 'GENERAR_REPORTE_ACUMULADO';
export const LIMPIAR_SENSORES = 'LIMPIAR_SENSORES';

export const LIMPIAR_ESTADO_USUARIO = 'LIMPIAR_ESTADO_USUARIO';
export const LIMPIAR_ESTADO_EMPRESA = 'LIMPIAR_ESTADO_EMPRESA';
export const LIMPIAR_ESTADO_PROYECTO = 'LIMPIAR_ESTADO_PROYECTO';
export const LIMPIAR_ESTADO_ELEMENTO = 'LIMPIAR_ESTADO_ELEMENTO';
export const LIMPIAR_ESTADO_TARJETA = 'LIMPIAR_ESTADO_TARJETA';
export const LIMPIAR_ESTADO_SENSOR = 'LIMPIAR_ESTADO_SENSOR';
export const LIMPIAR_ESTADO_GRAFICA = 'LIMPIAR_ESTADO_GRAFICA';
export const LIMPIAR_ESTADO_REPORTE = 'LIMPIAR_ESTADO_REPORTE';
export const CHANGE_TIPO_REPORTE = 'CHANGE_TIPO_REPORTE';

// logs
export const FETCH_LOGS = 'FETCH_LOGS';
export const FETCH_LOG_BY_ID = 'FETCH_LOG_BY_ID';
export const FETCH_LOG_STATS = 'FETCH_LOG_STATS';
export const CLEANUP_LOGS = 'CLEANUP_LOGS';
export const LIMPIAR_ESTADO_LOGS = 'LIMPIAR_ESTADO_LOGS';

// privilegios
export const FETCH_PRIVILEGIOS_REQUEST = 'FETCH_PRIVILEGIOS_REQUEST';
export const FETCH_PRIVILEGIOS_SUCCESS = 'FETCH_PRIVILEGIOS_SUCCESS';
export const FETCH_PRIVILEGIOS_FAILURE = 'FETCH_PRIVILEGIOS_FAILURE';
export const FETCH_PRIVILEGIOS_USUARIO_REQUEST = 'FETCH_PRIVILEGIOS_USUARIO_REQUEST';
export const FETCH_PRIVILEGIOS_USUARIO_SUCCESS = 'FETCH_PRIVILEGIOS_USUARIO_SUCCESS';
export const FETCH_PRIVILEGIOS_USUARIO_FAILURE = 'FETCH_PRIVILEGIOS_USUARIO_FAILURE';
export const CREATE_PRIVILEGIO_REQUEST = 'CREATE_PRIVILEGIO_REQUEST';
export const CREATE_PRIVILEGIO_SUCCESS = 'CREATE_PRIVILEGIO_SUCCESS';
export const CREATE_PRIVILEGIO_FAILURE = 'CREATE_PRIVILEGIO_FAILURE';
export const UPDATE_PRIVILEGIO_REQUEST = 'UPDATE_PRIVILEGIO_REQUEST';
export const UPDATE_PRIVILEGIO_SUCCESS = 'UPDATE_PRIVILEGIO_SUCCESS';
export const UPDATE_PRIVILEGIO_FAILURE = 'UPDATE_PRIVILEGIO_FAILURE';
export const DELETE_PRIVILEGIO_REQUEST = 'DELETE_PRIVILEGIO_REQUEST';
export const DELETE_PRIVILEGIO_SUCCESS = 'DELETE_PRIVILEGIO_SUCCESS';
export const DELETE_PRIVILEGIO_FAILURE = 'DELETE_PRIVILEGIO_FAILURE';
export const OTORGAR_PRIVILEGIOS_MASIVOS_REQUEST = 'OTORGAR_PRIVILEGIOS_MASIVOS_REQUEST';
export const OTORGAR_PRIVILEGIOS_MASIVOS_SUCCESS = 'OTORGAR_PRIVILEGIOS_MASIVOS_SUCCESS';
export const OTORGAR_PRIVILEGIOS_MASIVOS_FAILURE = 'OTORGAR_PRIVILEGIOS_MASIVOS_FAILURE';
export const VERIFICAR_PRIVILEGIO_REQUEST = 'VERIFICAR_PRIVILEGIO_REQUEST';
export const VERIFICAR_PRIVILEGIO_SUCCESS = 'VERIFICAR_PRIVILEGIO_SUCCESS';
export const VERIFICAR_PRIVILEGIO_FAILURE = 'VERIFICAR_PRIVILEGIO_FAILURE';
export const FETCH_RESUMEN_PRIVILEGIOS_REQUEST = 'FETCH_RESUMEN_PRIVILEGIOS_REQUEST';
export const FETCH_RESUMEN_PRIVILEGIOS_SUCCESS = 'FETCH_RESUMEN_PRIVILEGIOS_SUCCESS';
export const FETCH_RESUMEN_PRIVILEGIOS_FAILURE = 'FETCH_RESUMEN_PRIVILEGIOS_FAILURE';
export const LIMPIAR_PRIVILEGIOS_STATE = 'LIMPIAR_PRIVILEGIOS_STATE';

// dispositivos
export const CAMBIAR_ESTADO_DISPOSITIVO_REQUEST = 'CAMBIAR_ESTADO_DISPOSITIVO_REQUEST';
export const CAMBIAR_ESTADO_DISPOSITIVO_SUCCESS = 'CAMBIAR_ESTADO_DISPOSITIVO_SUCCESS';
export const CAMBIAR_ESTADO_DISPOSITIVO_ERROR = 'CAMBIAR_ESTADO_DISPOSITIVO_ERROR';
export const GET_ESTADO_DISPOSITIVOS_REQUEST = 'GET_ESTADO_DISPOSITIVOS_REQUEST';
export const GET_ESTADO_DISPOSITIVOS_SUCCESS = 'GET_ESTADO_DISPOSITIVOS_SUCCESS';
export const GET_ESTADO_DISPOSITIVOS_ERROR = 'GET_ESTADO_DISPOSITIVOS_ERROR';
export const CONFIGURAR_ALWAYS_ON_REQUEST = 'CONFIGURAR_ALWAYS_ON_REQUEST';
export const CONFIGURAR_ALWAYS_ON_SUCCESS = 'CONFIGURAR_ALWAYS_ON_SUCCESS';
export const CONFIGURAR_ALWAYS_ON_ERROR = 'CONFIGURAR_ALWAYS_ON_ERROR';
export const CAMBIO_ESTADO_MASIVO_REQUEST = 'CAMBIO_ESTADO_MASIVO_REQUEST';
export const CAMBIO_ESTADO_MASIVO_SUCCESS = 'CAMBIO_ESTADO_MASIVO_SUCCESS';
export const CAMBIO_ESTADO_MASIVO_ERROR = 'CAMBIO_ESTADO_MASIVO_ERROR';

// Dashboard
export const FETCH_DASHBOARD = 'FETCH_DASHBOARD';
export const FETCH_GRAFICAS_FAVORITAS = 'FETCH_GRAFICAS_FAVORITAS';
export const FETCH_CONTADORES = 'FETCH_CONTADORES';
export const FETCH_ULTIMOS_SENSORES = 'FETCH_ULTIMOS_SENSORES';
export const FETCH_CONSUMO_ENERGIA = 'FETCH_CONSUMO_ENERGIA';
export const TOGGLE_FAVORITE_GRAFICA = 'TOGGLE_FAVORITE_GRAFICA';
export const SET_DASHBOARD_LOADING = 'SET_DASHBOARD_LOADING';
export const SET_DASHBOARD_ERROR = 'SET_DASHBOARD_ERROR';
